import { connect } from 'react-redux';
import { changeView, restartQuiz } from '../../actions/actions';
import Header from './Header';

const mapStateToProps = (state) => {
  return {
    view: state.view,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeView: (view, prev) => {
      dispatch(changeView(view, prev));
    },
    restartQuiz: () => {
      dispatch(restartQuiz());
    },
  };
};

const HeaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);

export default HeaderContainer;



/** WEBPACK FOOTER **
 ** ./src/components/Header/HeaderContainer.js
 **/